import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface InfoSnackData {
  iconClass?: string;
  lableText?: string;
  text?: string;
};

@Component({
  templateUrl: 'info-snack.component.html',
  styleUrls: ['info-snack.component.scss'],
  standalone: false
})
export class InfoSnackComponent {
  constructor(
    public dialogRef: MatSnackBarRef<InfoSnackComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: InfoSnackData
  ) {
  }
}
